"use strict";

var _regeneratorRuntime = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var web3_1 = __importDefault(require("web3"));

var web3_utils_1 = require("web3-utils");

function getComponent(key, components) {
  // @ts-ignore
  var component = components[key];

  if (component != null) {
    return component;
  }

  return components.find(function (it) {
    return it.name === key;
  });
}

function retypeItem(abiOutput, ret) {
  if (abiOutput.type.includes('int')) {
    return web3_utils_1.toBN(ret);
  } else if (abiOutput.type.includes('tuple') && abiOutput.components != null) {
    var keys = Object.keys(ret);
    var newRet = {};

    for (var i = 0; i < keys.length; i++) {
      var component = getComponent(keys[i], abiOutput.components);

      if (component == null) {
        continue;
      }

      newRet[keys[i]] = retypeItem(component, ret[keys[i]]);
    }

    return newRet;
  } else {
    return ret;
  }
} // restore TF type: uint are returned as string in web3, and as BN in TF.


function retype(outputs, ret) {
  if ((outputs === null || outputs === void 0 ? void 0 : outputs.length) === 1) {
    return retypeItem(outputs[0], ret);
  } else {
    return ret;
  }
}

var Contract = /*#__PURE__*/function () {
  function Contract(contractName, abi) {
    _classCallCheck(this, Contract);

    this.contractName = contractName;
    this.abi = abi;
  }

  _createClass(Contract, [{
    key: "createContract",
    value: function createContract(address) {
      return new this.web3.eth.Contract(this.abi, address);
    } // return a contract instance at the given address.
    // UNLIKE TF, we don't do any on-chain check if the contract exist.
    // the application is assumed to call some view function (e.g. version) that implicitly verifies a contract
    // is deployed at that address (and has that view function)

  }, {
    key: "at",
    value: function () {
      var _at = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(address) {
        var contract, obj;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                contract = this.createContract(address);
                obj = {
                  address: address,
                  contract: contract,
                  getPastEvents: function getPastEvents(name, options) {
                    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              return _context.abrupt("return", contract.getPastEvents(name, options).map(function (e) {
                                return Object.assign(Object.assign({}, e), {
                                  args: e.returnValues // TODO: web3 uses strings, Truffle uses BN for numbers

                                });
                              }));

                            case 1:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }))();
                  }
                };
                this.abi.forEach(function (m) {
                  var _a, _b, _c;

                  var methodName = (_a = m.name) !== null && _a !== void 0 ? _a : '';
                  var nArgs = (_c = (_b = m.inputs) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
                  var isViewFunction = m.stateMutability === 'view' || m.stateMutability === 'pure';
                  obj[methodName] = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                    var args,
                        options,
                        methodCall,
                        _args2 = arguments;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            args = Array.from(_args2);

                            if (args.length === nArgs + 1 && typeof args[args.length - 1] === 'object') {
                              options = args[args.length - 1];
                              args = args.slice(0, args.length - 1);
                            }

                            methodCall = contract.methods[methodName].apply(contract.methods, args);

                            if (isViewFunction) {
                              _context2.next = 7;
                              break;
                            }

                            return _context2.abrupt("return", methodCall.send(options));

                          case 7:
                            return _context2.abrupt("return", methodCall.call(options).then(function (res) {
                              return retype(m.outputs, res);
                            }));

                          case 8:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));
                });
                return _context3.abrupt("return", obj);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function at(_x) {
        return _at.apply(this, arguments);
      }

      return at;
    }()
  }, {
    key: "setProvider",
    value: function setProvider(provider, _) {
      this.web3 = new web3_1.default(provider);
    }
  }]);

  return Contract;
}();

exports.Contract = Contract;

function TruffleContract(_ref2) {
  var contractName = _ref2.contractName,
      abi = _ref2.abi;
  return new Contract(contractName, abi);
}

exports.TruffleContract = TruffleContract;